import { Button, Modal } from "antd";
import { cloneElement, ReactElement, ReactNode, useRef, useState } from "react";
import DataInspector, { DataInspectorRef } from "./DataInspector";

interface Props<T> {
  icon?: ReactNode;
  component?: ReactElement;
  title: ReactNode;
  disabled?: boolean;
  children?: ReactNode;
  onSubmit?: (values: T) => void;
}

export function DataConfirm<T>({
  icon,
  component,
  title,
  disabled,
  children,
  onSubmit,
}: Props<T>) {
  const ref = useRef<DataInspectorRef<T>>(null);
  const [visible, setVisible] = useState(false);

  return (
    <>
      {component ? (
        cloneElement(component, {
          disabled,
          onClick: () => {
            ref.current?.reset();
            setVisible(true);
          },
        })
      ) : (
        <Button
          disabled={disabled}
          color="primary"
          variant="link"
          style={{ width: "auto" }}
          onClick={() => {
            ref.current?.reset();
            setVisible(true);
          }}
          icon={icon}
        />
      )}
      <Modal
        zIndex={980}
        open={visible}
        centered
        closable={false}
        maskClosable={false}
        title={title}
        okText="确认"
        cancelText="取消"
        onOk={() => {
          ref.current?.submit();
        }}
        onCancel={() => setVisible(false)}
      >
        <DataInspector<T>
          ref={ref}
          onFinish={(values) => {
            setVisible(false);
            onSubmit?.(values);
          }}
        >
          {children}
        </DataInspector>
      </Modal>
    </>
  );
}
